import _defaults from 'lodash/defaults'

export default {
  getters: {
    ToDo: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId ? getters.Trips[getters.currentTripDashboardId].to_do : {},
        {
          'section-heading': 'To Do List',
          'section-subheading': getters.Trips[getters.currentTripDashboardId]['section-subheading'] ?? '',
          'congratulations-heading': 'Congratulations!',
          'congratulations-body': '<p>You have completed all your tasks, you are ready to go!</p>'
        }
      )
    }
  }
}
